<script lang="ts" setup>
import { defineProps } from "vue";

const props = defineProps<{
  type: "companies" | "lists";
  onOpenList: () => void;
  onCreateList: () => void;
}>();
</script>

<template>
  <div class="charts-dashboard__empty-state">
    <div class="icon">
      <img src="img/no-matches.svg" />
    </div>
    <div class="text">
      <span v-if="props.type === 'lists'">No lists available.</span>
      <span v-if="props.type === 'lists'">
        You havent created any lists yet. Start by creating a new list to keep
        track of relevant companies
      </span>

      <span v-if="props.type === 'companies'">No companies in the list.</span>
      <span v-if="props.type === 'companies'">
        Start adding companies to track your network’s milestone progress.
      </span>
    </div>

    <PxButton
      v-if="props.type === 'lists'"
      type="green"
      class="cta"
      @click="props.onCreateList"
    >
      <PxIcon :size="18" name="plus-white" />
      NEW LIST
    </PxButton>

    <PxButton
      v-if="props.type === 'companies'"
      type="green"
      class="milestone-progress-reports__nocompanies__cta"
      @click="props.onOpenList"
    >
      OPEN LIST
    </PxButton>
  </div>
</template>

<style lang="scss" scoped>
.charts-dashboard__empty-state {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: calc(100vh - 445px);

  .text {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
